import {Accordion, Form, FormCheck, FormLabel} from "react-bootstrap";
import PropTypes from "prop-types";

function FormControlElement({elementType, params}) {
  const label = <FormLabel className={(["check", "radio"].includes(elementType)) ? "d-none" : "m-0 p-0"}>{params.label}</FormLabel>;
  
  let content = null;
  
  if (elementType === "check") {
    content = (
      <FormCheck
        type="switch"
        {...params}
      />
    );
  } else if (elementType === "range") {
    content = (
      <div className={"d-inline-flex align-items-center gap-1"}>
        <Form.Range
          style={{maxWidth: "100px"}}
          {...params}
        />
        <span className={"text-small text-muted"}>
          {params.value === 0 ? <>sem som</> : <>{params.value}%</>}
        </span>
      </div>
    );
  }
  
  if (label && content) {
    return (
      <div className={"d-inline-flex align-items-center gap-3 flex-wrap"}>
        {label}
        {content}
      </div>
    );
  }
  
  return null;
}

export function LiveConfigs({configs, setConfigs, labelsConfigs, resultSection}) {
  const handleChange = ((e) => {
    const {id, type} = e.target;
    let value;
    
    if (type === "checkbox" || type === "radio") value = e.target.checked;
    else if (type === "range") value = Math.round(+e.target.value);
    else value = e.target.value;
    
    setConfigs(prev => {
      return {
        ...prev,
        [id]: value
      }
    });
    
    // Scroll até a seção de resultados
    if (resultSection.current) window.scrollTo({top: resultSection.current.offsetTop - (16 * 8), behavior: "smooth"})
  });
  
  // Registrar configs em localstorage para persistência
  return (
    <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header className={"inter"}>Configurações</Accordion.Header>
        <Accordion.Body>
          <Form className={"d-flex align-items-center flex-wrap gap-2 justify-content-evenly mt-1"}>
            {
              typeof configs === "object" ? Object.entries(configs)
                .map((c, index) => {
                  return (
                    <FormControlElement
                      key={index}
                      elementType={typeof c?.[1] === "boolean" ? "check" : "range"}
                      params={{
                        id: c[0],
                        label: labelsConfigs?.current?.[c[0]] ?? ("Configuração #" + index),
                        value: typeof c?.[1] !== "boolean" ? c?.[1] : undefined,
                        checked: typeof c?.[1] === "boolean" ? c?.[1] : undefined,
                        onChange: handleChange,
                      }}
                    />
                  )
                }) : ""
            }
          </Form>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

LiveConfigs.propTypes = {
  configs: PropTypes.object.isRequired,
  setConfigs: PropTypes.any.isRequired,
  labelsConfigs: PropTypes.object.isRequired,
  resultSection: PropTypes.object.isRequired,
}

FormControlElement.propTypes = {
  elementType: PropTypes.string.isRequired,
  params: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    checked: PropTypes.any,
    label: PropTypes.string.isRequired,
  })
}
